module.exports = "<vb-autocomplete\r\n  [items]=\"depotYards\"\r\n  [loading]=\"loading\"\r\n  [item]=\"item\"\r\n  [control]=\"control\">\r\n</vb-autocomplete>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/depot/depot-yard-input/depot-yard-input.component.html
// module id = ./src/app/store-management/depot/depot-yard-input/depot-yard-input.component.html
// module chunks = main